"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MerchandisingBlock = void 0;
var _react = require("react");
var _constants = require("../constants");
var _BackorderItem = require("./BackorderItem");
var _CustomerOrderItem = require("./CustomerOrderItem");
var _MerchandizingItem = require("./MerchandizingItem");
var _jsxRuntime = require("react/jsx-runtime");
const MerchandisingBlock = ({
  'data-testid': testId,
  text,
  toolTip,
  hintCategory,
  title,
  progress,
  ordersAmount,
  pendingOrders,
  ordersPageLink
}) => {
  const isCustomerOrderItem = hintCategory === 'EndConsumerOrders';
  const isBackorderItem = hintCategory === 'BackOrders';
  const color = _constants.BadgeColors[hintCategory];
  const commonProps = {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- x
    'data-testid': testId,
    color,
    text,
    title
  };
  const [shouldShowModal, setShouldShowModal] = (0, _react.useState)(false);
  const handleOpenModal = (0, _react.useCallback)(() => {
    setShouldShowModal(true);
  }, [setShouldShowModal]);
  const handleCloseModal = (0, _react.useCallback)(e => {
    e.stopPropagation();
    setShouldShowModal(false);
  }, [setShouldShowModal]);
  if (isCustomerOrderItem) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomerOrderItem.CustomerOrderItem, {
      ...commonProps,
      handleCloseModal: handleCloseModal,
      handleOpenModal: handleOpenModal,
      shouldShowModal: shouldShowModal,
      ordersAmount: ordersAmount ?? 0,
      pendingOrders: pendingOrders ?? [],
      ordersPageLink: ordersPageLink
    });
  } else if (isBackorderItem) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_BackorderItem.BackorderItem, {
      ...commonProps,
      toolTip: toolTip
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MerchandizingItem.MerchandizingItem, {
    ...commonProps,
    progress: progress
  });
};
exports.MerchandisingBlock = MerchandisingBlock;